import {
    Button,
    capitalize, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItem,
    ListItemText, Slide
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import * as React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props}/>;
});

const ModalSuccessOrError = (
    {
        openDialog = false,
        setOpenDialog = () => {},
        fetchErrors = [],
        titleSuccess = 'Datos registrados con éxito',
        titleError = '¡Ups! Al parecer hubo un error'
    }
) => {
    return (
        <Dialog
            open={openDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setOpenDialog(false)}
        >
            {fetchErrors.length > 0 && (
                <DialogTitle textAlign={'center'}>{titleError}</DialogTitle>
            )}
            {fetchErrors.length === 0 && (
                <DialogTitle textAlign={'center'}>{titleSuccess}</DialogTitle>
            )}
            <DialogContent>
                <DialogContentText textAlign={'center'}>
                    {fetchErrors.length > 0 && (
                        <ErrorIcon style={{height: '20%', width: '20%'}} color='error'/>
                    )}
                    {fetchErrors.length === 0 && (
                        <CheckCircleOutlineIcon style={{height: '20%', width: '20%'}} color='primary'/>
                    )}
                </DialogContentText>
                {fetchErrors && fetchErrors.length > 0 && (
                    <DialogContentText>
                        <List>
                            {fetchErrors && fetchErrors.length > 0 && fetchErrors.map((error, index) => (
                                <ListItem key={index}>
                                    <ListItemText primary={`${index + 1}. ${capitalize(error.message)}`}/>
                                </ListItem>
                            ))}
                        </List>
                    </DialogContentText>
                )}
            </DialogContent>
            {fetchErrors.length > 0 && (
                <DialogActions>
                    <Button fullWidth onClick={() => setOpenDialog(false)}>
                        Aceptar
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
export {ModalSuccessOrError}